export default __webpack_public_path__ + "static/media/bundling-shirt-page1.70689664.png";